module.exports = __webpack_public_path__ + "img/red-rectangle-table-10.062e85b4.png";